import React from "react";
import Header from "./Header";
import Footer from "./Footer";
import "../css/terms.scss";
import { Link } from "react-router-dom";

function Terms() {
  const toTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };
  return (
    <body className=" color-scheme color-scheme--scheme-1">
      <Header />
      <main id="page-content-layer">
        <div className="TermsAndConditionsPage_main__t472A">
          <h1 className="textHeadingL_className__KQ29Z">
            Terms and conditions
          </h1>
          <p className="textBodyS_className__i7HOx">
            Latest version:{" "}
            <time dateTime="2025-08-05T09:56:40.983Z">05/08/2025</time>
          </p>
          <h2 className="textHeadingL_className__KQ29Z">Introduction</h2>
          <section className="SectionParagraphList_content__0Uxag">
            <article className="SectionParagraph_contentText__4GBlt">
              <div>
                <p>
                  Mangoes offers you an online purchasing service which allows
                  you to purchase a selection of the items available at our
                  stores from your computer. You can also benefit from
                  promotions, gifts and exclusive offers.
                </p>
                <p>
                  Below, we invite you to review the general conditions of sale
                  which regulate the purchase of Mangoes products via this
                  Website. Therefore, use of this Webpage implies your
                  acceptance of these general conditions of sale. However, if
                  you have any queries regarding the same, please contact our{" "}
                  <Link
                    onClick={toTop}
                    className="textBodyLinkM_className__QAb_D GenericStyles_anchor__uq5eo"
                    to="/"
                  >
                    <span className="textBodyM_className__v9jW9 GenericStyles_underline__n3GcV">
                      <span className="textBodyMStrong_className__yXgeE">
                        Customer Services
                      </span>
                    </span>
                  </Link>{" "}
                  department.
                </p>
              </div>
            </article>
          </section>
          <h2 className="textHeadingL_className__KQ29Z">Our details</h2>
          <section className="SectionParagraphList_content__0Uxag">
            <article className="SectionParagraph_contentText__4GBlt">
              <div>
                <p>
                  The following conditions regulate the sale of products
                  featured on this Webpage by the company:
                </p>
                <p>Mangoes MNG, S.A. (hereinafter, “Manyou”)</p>
                <p>
                  Via Augusta, 10
                  <br />
                  Pol. Ind. Riera de Caldes
                  <br />
                  C.P. 08184 Palau-solità i Plegamans
                  <br />
                  Barcelona (Spain)
                </p>
                <p>
                  Registered in the Barcelona Companies Register under
                  Volume/IRUS 1000318835574, Folio 3, Sheet B 167948, Entry 147
                  and with VAT Number ES-A59088948.
                </p>
              </div>
            </article>
          </section>
          <h2 className="textHeadingL_className__KQ29Z">Contract</h2>
          <section className="SectionParagraphList_content__0Uxag">
            <article className="SectionParagraph_contentText__4GBlt">
              <div>
                <h3>Availability of the service</h3>
                <p>
                  By placing an order on the Website/App, you guarantee that you
                  are 18 years old or over. The products offered are distributed
                  in the following member states of the European Union: Austria,
                  Belgium, Bulgaria, Croatia, Cyprus (southern area), Czech
                  Republic, Denmark, Estonia, Finland, France (metropolitan
                  area), Germany, Greece, Hungary, Ireland, Italy (except San
                  Marino, Livigno, Campione, Vatican City and Italian waters of
                  Lake Lugano), Latvia, Lithuania, Luxembourg, Malta,
                  Netherlands, Poland, Portugal, Romania, Slovakia, Slovenia,
                  Spain (including the Canary Islands, Ceuta and Melilla),
                  Sweden and the United Kingdom.Our products are also
                  distributed in the following countries:Albania, Andorra,
                  Aruba, Australia, Bahrain, Bosnia-Herzegovina, Canada, Channel
                  Islands, China, Colombia, Costa Rica, Curaçao, Egypt, French
                  Guyana, Guadeloupe, Guatemala, Hong Kong, India, Indonesia,
                  Iceland, Jordan, Kazakhstan, Kuwait, Lebanon, Liechtenstein,
                  Macao, Malaysia, Maldives, Martinique, Mexico, Monaco,
                  Nicaragua, Norway, Qatar, Oman, Panama, Philippines, Russia,
                  Salvador, Saudi Arabia, Serbia, Singapore, South Africa, South
                  Korea, Switzerland, Turkey, United Arab Emirates, United
                  States, Uzbekistan.
                </p>
                <p>
                  You may purchase from the country of your choice, but we are
                  only able to send your order to addresses located in the
                  chosen country.The delivery methods, conditions of sale and
                  delivery points will be updated when you change the country.
                </p>
                <h3>Purchase guarantee</h3>
                <p>
                  The items offered on this Webpage are a selection of products
                  from the Women’s and Children’s collections and meet the same
                  quality requirements and guarantee as the products on sale at
                  Mangoes Group stores.
                </p>
                <p>Each product features the following details:</p>
                <p>
                  Name of the article
                  <br />
                  Photo of the article
                  <br />
                  Description of the article
                  <br />
                  Available sizes and colours*
                  <br />
                  Composition
                  <br />
                  Wash and care instructions
                  <br />
                  Price (in the corresponding currency)
                </p>
                <p>
                  *Mangoes has made every effort to display the colours of the
                  items as realistically as possible. However, the colour of the
                  garments that appear on the screen may be subject to changes
                  depending on the quality of your computer monitor. Therefore,
                  Mangoes cannot guarantee that the colours that appear on your
                  monitor are a true representation of the actual colours.
                </p>
                <p>
                  Special offers, promotions or discounts will be valid until
                  the indicated date or while stocks last.
                </p>
                <p>
                  Similarly, Mangoes makes every effort to ensure that the
                  information contained on its website is complete, accurate and
                  correct. In the event of any error, Mangoes will proceed to
                  correct it immediately.
                </p>
                <h3>Purchase procedure</h3>
                <ol>
                  <li>
                    Select the articles you wish to purchase and add them to the
                    shopping basket, by clicking on the corresponding icon.
                  </li>
                  <li>
                    The shopping basket contains the reference of the selected
                    item, its name, size, colour and price in the corresponding
                    country (including taxes). The quoted price does not include
                    transport costs, which will vary according to the delivery
                    method selected.
                  </li>
                  <li>
                    To proceed with the purchase, the user’s personal details
                    will be required and will be included on our database in
                    order to process the order and simplify future purchases via
                    the Website. The personal details provided by users will be
                    treated in accordance with our{" "}
                    <Link
                      onClick={toTop}
                      className="textBodyLinkM_className__QAb_D GenericStyles_anchor__uq5eo"
                      to="/"
                    >
                      <span className="textBodyM_className__v9jW9 GenericStyles_underline__n3GcV">
                        <span className="textBodyMStrong_className__yXgeE">
                          Privacy Policy
                        </span>
                      </span>
                    </Link>
                    . Users may, at any moment, access the personal details they
                    have provided and information on the orders they have
                    placed. Mangoes reminds users that their personal details
                    must be as accurate as possible in order to avoid any
                    confusion or errors in the dispatch of the item(s)
                    purchased. Furthermore, wherever expressly requested by
                    users, they will receive information and publications
                    relative to the Mangoes Group by post and/or SMS.
                  </li>
                  <li>
                    Once the order has been completed, and before the order is
                    confirmed, the user will be provided with an itemised
                    summary of the order, identifying the item(s) purchased, the
                    total price (including transport and taxes) and the order
                    delivery details, in order for the user to confirm this by
                    clicking on the 'Confirm payment' button.
                  </li>
                </ol>
                <p>
                  Purchases may be paid for using a credit or debit card (Visa,
                  Visa Electron, MasterCard and American Express) or via PayPal.
                  Payment method other than the ones specified in the present
                  conditions of sale will not be accepted. For payments by
                  credit or debit card, the charge will be made online, in other
                  words, in real time, through the payment gateway of the
                  corresponding financial entity, once it has been confirmed
                  that the data sent by the user is correct.
                </p>
                <p>
                  Once the transaction has been confirmed, the order number will
                  be displayed on the webpage, allowing users to track the order
                  from their computer at any moment.
                </p>
                <p>
                  An automated order confirmation e-mail will also be sent to
                  the address indicated by the user with acknowledgement of
                  receipt, with a description of the order and the personal
                  details provided. If you do not receive this e-mail, this
                  could be due to a temporary communications problem in the
                  network or an error in the e-mail address entered. In both
                  cases, Mangoes advises the user to contact{" "}
                  <Link
                    onClick={toTop}
                    className="textBodyLinkM_className__QAb_D GenericStyles_anchor__uq5eo"
                    to="/"
                  >
                    <span className="textBodyM_className__v9jW9 GenericStyles_underline__n3GcV">
                      <span className="textBodyMStrong_className__yXgeE">
                        Customer Services
                      </span>
                    </span>
                  </Link>
                  . Similarly, an e-mail will be sent to the user confirming
                  that the product has been dispatched.
                </p>
                <h3>Availability of products</h3>
                <p>
                  All orders are subject to the products being available. If, at
                  the time the order is issued, our warehouse detects that there
                  are no stocks of any of the products included within it,
                  Mangoes will make every effort to locate the item. If this is
                  not possible, the user will be notified immediately. In
                  addition, the amount charged for the unsent item will be
                  refunded to the customer, using the same payment method used
                  to purchase the item.
                </p>
                <h3>Right not to accept an order</h3>
                <p>
                  Mangoes may cancel or refuse to accept any confirmed order on
                  the following grounds:
                </p>
                <ol>
                  <li>
                    In the event of a technical and/or typing error in the
                    prices or other details of products contained on the webpage
                    when the order was placed.
                  </li>
                  <li>
                    Due to a lack of availability, as described in point 3.4.
                  </li>
                  <li>
                    When the security systems indicate that the order may be
                    fraudulent.
                  </li>
                  <li>
                    When there are reasons to indicate that the user is a minor.
                  </li>
                  <li>
                    If Mangoes was unable to deliver the order to the address
                    provided.
                  </li>
                </ol>
                <p>
                  Mangoes will fully reimburse any sums that have been paid.
                </p>
              </div>
            </article>
          </section>
          <h2 className="textHeadingL_className__KQ29Z">Price and payment</h2>
          <section className="SectionParagraphList_content__0Uxag">
            <article className="SectionParagraph_contentText__4GBlt">
              <div>
                <h3>Payment and currency</h3>
                <p>The prices on this Webpage are quoted in EUR.</p>
                <p>
                  Mangoes allows users the option to select the destination
                  country before placing their order, so that they can see the
                  prices with the corresponding taxes included. If the customer
                  subsequently modifies the delivery address and the destination
                  country, the prices displayed in the final summary of the
                  order may vary.
                </p>
                <h3>Taxes</h3>
                <p>
                  All products listed on your final order will include all
                  applicable taxes at the current rate in force.
                </p>
                <h3>Payment methods</h3>
                <p>
                  Mangoes only accepts payment by credit or debit card (Visa,
                  Visa Electron, MasterCard and American Express), or via
                  PayPal.
                </p>
                <p>
                  <span className="textBodyMStrong_className__yXgeE">
                    Payment by credit or debit card
                  </span>
                  <br />
                  Mangoes accepts payments for purchases made via its Website
                  with the following credit or debit cards: Visa, Visa Electron,
                  MasterCard and American Express.
                </p>
                <p>
                  For payments by credit or debit card, the charge will be made
                  online, in other words, in real time, through the payment
                  gateway of the corresponding financial entity, once it has
                  been confirmed that the data sent by the user is correct.
                </p>
                <p>
                  <span className="textBodyMStrong_className__yXgeE">
                    Payment via PayPal
                  </span>
                  <br />
                  Mangoes will process the payment via the Paypal system.
                </p>
                <p>
                  <span className="textBodyMStrong_className__yXgeE">
                    Paypal express payment
                  </span>
                  <br />
                  Customers can link their Paypal account to their Mangoes
                  account. This way, they will not have to enter their details
                  every time they make a purchase via this system.
                </p>
                <h3>Payment security</h3>
                <p>
                  In order to offer maximum security in the payment system,
                  Mangoes uses the secure payment systems of the leading
                  financial entities in e-commerce. Therefore, all confidential
                  data is transferred directly and in an encrypted format (SSL)
                  to the corresponding financial entity. For payment by Visa and
                  MasterCard, Mangoes only accepts SET transactions (Secure
                  Electronic Transactions) using the 3D Secure international
                  protocol, which can be identified by the Verified by Visa and
                  MasterCard SecureCode logos. The basic aim of the Secure
                  Electronic Transactions initiative is to guarantee the
                  security of Internet transactions. When you make payment
                  through the secure payment gateway, the system will
                  automatically check whether the credit card has been activated
                  for Secure Electronic Transactions. Next, it will connect with
                  the issuing bank of the card, which will request authorisation
                  for the operation via a personal authentication code. The
                  operation will only proceed if the issuing bank of the card
                  confirms the authentication code. In all other cases, the
                  transaction will be rejected. We also have the GeoTrust SSL
                  safety certificate for online transactions.
                </p>
                <p>
                  As a complementary measure to the ‘Secure payment’ system, and
                  in order to collaborate in the prevention of Internet fraud,
                  Mangoes reserves the right to check the personal details
                  provided by customers and to take the appropriate steps
                  (including the cancellation of the order) in order to ensure
                  that goods are dispatched in accordance with the data that is
                  stated on the order.
                </p>
                <h3>Purchase limit</h3>
                <p>
                  Mangoes does not permit the purchase of Mangoes products for
                  subsequent resale. Consequently, it is not possible to make
                  purchases for an amount that exceeds HK$ 15,000, or for more
                  than 40 items. Customers who wish to make purchases in excess
                  of said amount or quantity for purposes other than resale
                  should contact{" "}
                  <Link
                    onClick={toTop}
                    className="textBodyLinkM_className__QAb_D GenericStyles_anchor__uq5eo"
                    to="/"
                  >
                    <span className="textBodyM_className__v9jW9 GenericStyles_underline__n3GcV">
                      <span className="textBodyMStrong_className__yXgeE">
                        Customer Services
                      </span>
                    </span>
                  </Link>
                  , where they will be informed of the various options for
                  making the desired purchase.
                </p>
              </div>
            </article>
          </section>
          <h2 className="textHeadingL_className__KQ29Z">Delivery</h2>
          <section className="SectionParagraphList_content__0Uxag">
            <article className="SectionParagraph_contentText__4GBlt">
              <div>
                <p>
                  Delivery of items purchased at www.mangoes.pro will be carried
                  out via an international courier company and delivered in
                  approximately 2 to 5 working days. Delivery is free for orders
                  over HK$ 1,500, and charged at HK$ 100 in the case of orders
                  below this amount.
                </p>
                <p>
                  In order to avoid any delivery problems (incorrect addresses,
                  nobody at home, etc.), you must complete the applicable form
                  correctly and it is advisable to leave a contact telephone
                  number in the corresponding field.
                </p>
                <p>
                  Orders can be tracked via the www.mangoes.pro Webpage,
                  indicating the location of the goods at each moment until
                  final reception.
                  <br />
                  The delivery cost is calculated according to the delivery
                  method chosen and the items purchased. The exact transport
                  cost will be calculated every time an item is added to the
                  shopping basket, and will be displayed on the order summary
                  page that appears before the customer confirms the order by
                  pressing the ‘Confirm Payment’ button, and before the credit
                  card or debit card details are entered.
                </p>
                <p>Orders cannot be delivered to military bases or PO boxes.</p>
                <p>
                  The delivery charges may be altered at any time without prior
                  notice. Said change shall become effective from the moment the
                  modification appears in the help pages and in the contract
                  published on this Webpage. In all cases, the delivery charges
                  that appear at the moment the order is placed shall apply.
                </p>
              </div>
            </article>
          </section>
          <h2 className="textHeadingL_className__KQ29Z" id="returns">
            Online exchanges and/or returns policy
          </h2>
          <section className="SectionParagraphList_content__0Uxag">
            <article className="SectionParagraph_contentText__4GBlt">
              <div>
                <h3>Exchange and/or returns conditions</h3>
                <p>
                  The Customer has the right to withdraw from the purchase and
                  return the product(s) purchased and/or exchange their size
                  (except for the products described in clause 6.2. below),
                  without the need for justification, within 30 calendar days
                  from the dispatch date. If the products in their confirmed
                  order are delivered separately, on different dates, the
                  dispatch date of the last product shall apply for the purposes
                  of the return.
                </p>
                <p>
                  Mangoes cannot accept exchanges or returns of used or damaged
                  items (except in the case of flaws). For reasons of hygiene,
                  underwear and swimwear items are fitted with a safety seal to
                  prevent them being tried on or worn. If you wish to return
                  this type of item, the label and the safety seal must remain
                  intact.
                </p>
                <p>
                  Face masks cannot be exchanged or returned for health and
                  safety reasons.
                </p>
                <p>
                  For reasons of hygiene, earrings cannot be exchanged or
                  returned.
                </p>
                <p>
                  It is not possible to change one model for another: it is only
                  possible to exchange it for a different size. To exchange one
                  item for another, you must follow the refund procedure and
                  make a new purchase.
                </p>
                <p>
                  All returns of purchased items must be carefully packaged and
                  include a duly completed delivery note or returns form.
                  <br />
                  If you do not have said delivery note when making the exchange
                  or return, you can download the returns form by accessing the
                  order page (in{" "}
                  <Link
                    onClick={toTop}
                    className="textBodyLinkM_className__QAb_D GenericStyles_anchor__uq5eo"
                    to="/"
                  >
                    <span className="textBodyM_className__v9jW9 GenericStyles_underline__n3GcV">
                      <span className="textBodyMStrong_className__yXgeE">
                        My purchases
                      </span>
                    </span>
                  </Link>{" "}
                  in My account section if you are registered, or in{" "}
                  <Link
                    onClick={toTop}
                    className="textBodyLinkM_className__QAb_D GenericStyles_anchor__uq5eo"
                    to="/"
                  >
                    <span className="textBodyM_className__v9jW9 GenericStyles_underline__n3GcV">
                      <span className="textBodyMStrong_className__yXgeE">
                        My purchases
                      </span>
                    </span>
                  </Link>{" "}
                  section if you are not) at www.mangoes.pro.
                </p>
                <p>
                  Mangoes reserves the right to review and evaluate each claim
                  related to undelivered or incomplete orders. If reasonable
                  indications of improper and/or fraudulent use of the Website
                  are detected in the fulfilment of such orders, Mangoes may
                  refuse the refund request and temporarily suspend the
                  Customer's account.
                </p>
                <h3>Store exchanges and/or returns</h3>
                <p>
                  Items purchased on this Webpage are part of the collection of
                  items on sale at physical stores of the Mangoes Group.
                  Therefore, depending on the stock of the store in question,
                  Mangoes offers you the possibility to exchange an item for
                  another size or to return an item. All items may be returned
                  to stores in Hong Kong that sell the collection being
                  returned.
                </p>
                <p>
                  In the case of refunds, customers will be given a till receipt
                  as proof of the return and a refund will be requested. The
                  details of the refund will be forwarded to our central offices
                  in Palau-Solità i Plegamans, from where the refund will be
                  processed via the same payment method used to purchase the
                  item.
                </p>
                <h3>Postal returns</h3>
                <p>
                  Returning a garment is possible by post, at the following
                  address:
                </p>
                <p>
                  Mangoes STORE
                  <br />
                  Central Queens Rd
                  <br />
                  59-65 Queens Road Central
                  <br />
                  Central, Hong Kong
                </p>
                <p>
                  In such cases, Mangoes recommends sending the return by
                  registered mail with acknowledgement of receipt.
                </p>
                <p>
                  The postage expenses of items being returned shall be borne by
                  the customer and under no circumstances will Mangoes accept
                  returns sent carriage due.
                </p>
                <p>Exchanges will not be accepted by post.</p>
                <h3>Returns of orders placed in stores via the iPad</h3>
                <p>
                  Orders placed via the iPad at physical stores of Mangoes may
                  be returned to the same store of purchase or by post to the
                  following address:
                </p>
                <p>
                  Mangoes STORE
                  <br />I Square Mall,
                  <br />
                  Shop 07, LB/F,
                  <br />
                  63 Nathan road,
                  <br />
                  Tsim Sha Tsui,
                  <br />
                  Kowloon, Hong Kong
                </p>
                <p>
                  In such cases, Mangoes recommends sending the return by
                  registered mail with acknowledgement of receipt.
                </p>
                <p>
                  The postage expenses of items being exchanged or returned
                  shall be borne by the customer and under no circumstances will
                  Mangoes accept returns sent carriage due.
                </p>
                <p>In this case, exchanges will not be accepted.</p>
                <h3>Refunds</h3>
                <p>
                  Once the items are received, Mangoes will ensure they are in
                  good condition and will dispatch the requested size in the
                  case of an exchange or refund the purchase amount via the same
                  payment method used in the purchase in the case of refunds.
                </p>
                <p>
                  The refund period may vary between 3 and 12 working days from
                  reception of the return at the Mangoes warehouses. Once the
                  condition of the returned items has been inspected, the
                  customer will be notified by e-mail.
                </p>
                <p>
                  The returned items will always be refunded via the same
                  payment method used to purchase them.
                </p>
                <p>
                  In cases where Mangoes has erroneously sent an item different
                  to the one ordered or the quality of the item sent is not
                  acceptable, Mangoes, once it has checked the error or defect,
                  will refund the price of the returned item and the postage
                  expenses. Whenever an erroneous or defective item is returned
                  by ordinary post, Mangoes will refund the corresponding
                  postage expenses provided the customer encloses a receipt of
                  the return expenses in the parcel. Please note that the
                  postage expenses will be reimbursed after the items are
                  reimbursed.
                </p>
                <p>
                  Mangoes shall not owe any liability to the customer when the
                  product contained in the parcel returned by the customer is
                  incorrect. Notwithstanding the above, in cases where the
                  customer erroneously sends a product different to the one
                  stated in the order and it is possible to process the
                  collection of the item, the customer must organise its return
                  and cover the corresponding costs of said collection.
                </p>
              </div>
            </article>
          </section>
          <h2 className="textHeadingL_className__KQ29Z">Warranties</h2>
          <section className="SectionParagraphList_content__0Uxag">
            <article className="SectionParagraph_contentText__4GBlt">
              <div>
                <p>
                  To customers who make purchases as consumers, Mangoes offers
                  warranties on the products marketed through the
                  Website/Application for any non-conformities regarding the
                  same that become apparent within a period of three (3) years
                  from delivery of the product.
                </p>
                <p>
                  In the absence of proof to the contrary, it shall be presumed
                  that any non-conformities that become apparent within two (2)
                  years of delivery of the product already existed when the
                  product was delivered.
                </p>
                <p>
                  Consequently, if any of the products do not conform to the
                  contract, the customer should notify Mangoes by any of the
                  communication methods set out below.
                </p>
              </div>
            </article>
          </section>
          <h2 className="textHeadingL_className__KQ29Z">Gift voucher</h2>
          <section className="SectionParagraphList_content__0Uxag">
            <article className="SectionParagraph_contentText__4GBlt">
              <div>
                <p>
                  Users may purchase gift vouchers solely at www.mangoes.pro to
                  purchase items on sale at said Website.
                </p>
                <p>
                  When purchasing a gift voucher, users cannot add any other
                  item to the order and may only purchase one gift voucher per
                  order.
                  <br />
                  <br />
                  In order to process the purchase of a gift voucher, the
                  following details of the person for whom it is intended will
                  be requested: name, surname(s) and e-mail. These details will
                  be used solely for the correct management of the gift voucher.
                </p>
                <p>
                  Only one gift voucher may be used per order as a payment
                  method and they cannot be used in conjunction with other
                  promotional discounts.
                </p>
                <p>
                  If the purchase amount is lower than the value of the gift
                  voucher, the remaining balance will be available to the user
                  for future purchases.
                </p>
                <p>
                  If the total purchase amount is greater than the value of the
                  gift voucher, the remaining balance must be paid by the
                  customer using the payment methods accepted at
                  www.mangoes.pro.
                </p>
                <p>
                  The exchanges and/or returns policy for orders paid for with
                  gift vouchers is the same as for all other orders placed at
                  www.mangoes.pro.
                  <br />
                  The refundable amount will be credited to the balance of the
                  gift voucher.
                </p>
                <p>
                  The crediting of the gift voucher will take approximately 15
                  days from the date of the refund. Once the gift voucher has
                  been credited, the user will be notified by e-mail of the new
                  balance available.
                </p>
                <p>
                  If part of the order has been paid for with a credit card, the
                  refundable amount will first be credited to the credit card
                  used, and the remainder of the refundable amount credited to
                  the balance of the gift voucher.
                </p>
                <p>
                  The balance of the gift voucher may be consulted at any moment
                  via the{" "}
                  <span className="textBodyM_className__v9jW9 GenericStyles_underline__n3GcV">
                    <span className="textBodyMStrong_className__yXgeE" />
                  </span>
                  <Link
                    onClick={toTop}
                    className="textBodyLinkM_className__QAb_D GenericStyles_anchor__uq5eo"
                    to="/"
                  >
                    <span className="textBodyM_className__v9jW9 GenericStyles_underline__n3GcV">
                      <span className="textBodyMStrong_className__yXgeE">
                        Gift Voucher
                      </span>
                    </span>
                  </Link>{" "}
                  option. All gift vouchers are valid for one year. Two week
                  before the gift voucher expires, the holder will be informed
                  by e-mail of the remaining period and the available balance on
                  their gift voucher, if applicable.
                </p>
              </div>
            </article>
          </section>
          <h2 className="textHeadingL_className__KQ29Z" id="promotions">
            Promotions
          </h2>
          <section className="SectionParagraphList_content__0Uxag">
            <article className="SectionParagraph_contentText__4GBlt">
              <div>
                <h3>10% OFF YOUR FIRST ORDER</h3>
                <p>
                  Code valid for 30 days from subscription. One-time use only.
                  Not valid with any other offer, discount or promotion. Not
                  applicable to those articles labelled with a star (*), a
                  circle (O) or a hashtag (#). Exclusive only for new
                  subscribers and online purchases.
                </p>
                <p>
                  This promotion is only available to subscribers who have not
                  completed the registration form on our website during the last
                  two years.
                </p>
              </div>
            </article>
          </section>
          <h2 className="textHeadingL_className__KQ29Z">Contact</h2>
          <section className="SectionParagraphList_content__0Uxag">
            <article className="SectionParagraph_contentText__4GBlt">
              <div>
                <p>
                  For any queries or suggestions, you may contact Mangoes by{" "}
                  <Link
                    onClick={toTop}
                    className="textBodyLinkM_className__QAb_D GenericStyles_anchor__uq5eo"
                    to="/"
                  >
                    <span className="textBodyM_className__v9jW9 GenericStyles_underline__n3GcV">
                      <span className="textBodyMStrong_className__yXgeE">
                        e-mail
                      </span>
                    </span>
                  </Link>{" "}
                  or by post at the following address:
                </p>
                <p>
                  <span className="textBodyMStrong_className__yXgeE">
                    Mangoes
                  </span>
                  <br />
                  Dpto. de Atención al Cliente
                  <br />
                  Via Augusta, 10
                  <br />
                  Pol. Ind. Riera de Caldes
                  <br />
                  C.P. 08184 Palau-solità i Plegamans
                  <br />
                  Barcelona (Spain)
                </p>
                <p>
                  The Customer Services telephone number is: +34 93 860 24 24.
                  The office hours are Monday to Friday from 9am to 9pm Spanish
                  local time (international call).
                </p>
                <p>
                  <span className="textBodyMStrong_className__yXgeE">
                    Opening Hours
                  </span>
                  <br />
                  www.mangoes.pro is open for business 24 hours a day, 7 days a
                  week, 365 days a year.
                </p>
                <p>
                  We remind you that you should not provide your card details
                  via e-mail, fax or social networks. For more information,
                  click{" "}
                  <span className="textBodyM_className__v9jW9 GenericStyles_underline__n3GcV">
                    <span className="textBodyMStrong_className__yXgeE" />
                  </span>
                  <Link
                    onClick={toTop}
                    className="textBodyLinkM_className__QAb_D GenericStyles_anchor__uq5eo"
                    to="/"
                  >
                    <span className="textBodyM_className__v9jW9 GenericStyles_underline__n3GcV">
                      <span className="textBodyMStrong_className__yXgeE">
                        here
                      </span>
                    </span>
                  </Link>
                  .
                </p>
              </div>
            </article>
          </section>
        </div>
        <div>
          <div className="Footer_footer__QfTV6">
            <h2 className="Footer_title__lArUt textBodyMStrong_className__yXgeE">
              10% off your next purchase by subscribing to the newsletter
            </h2>
            <form className="Form_form__HUtjp Footer_form__P1da_">
              <div className="Form_inputContainer__HYdK1">
                <div className="Input_inputWrapper__7tx4D">
                  <div className="Input_box__vAdaB">
                    <label
                      className="Input_label___ONtC textBodyM_className__v9jW9"
                      htmlFor="newsletter-form-email-input"
                    >
                      E-mail
                    </label>
                    <input
                      aria-invalid="false"
                      className="Input_input__sA8hs textBodyL_className__8D1Ya"
                      id="newsletter-form-email-input"
                      placeholder=""
                      type="text"
                      autoComplete="email"
                      aria-required="true"
                      name="email"
                      defaultValue=""
                    />
                  </div>
                </div>
                <button
                  className="ButtonBase_button__SOIgU textActionM_className__8McJk ButtonBase_fullWidth__g0ppN Form_submitButton__d1dGu ButtonSecondary_default__LzUq_"
                  id="newsletter-form-submit-button"
                  aria-describedby="newsletter-policy"
                  type="submit"
                  aria-disabled="false"
                >
                  <span className="ButtonContentWrapper_content__BD7dT">
                    Sign up now
                  </span>
                </button>
              </div>
              <dialog
                id="newsletter-generic-modal"
                className="Modal_modalTypeL__QvHdt Modal_dialog__ivY6s"
              />
            </form>
            <div className="ExpandableTextByLink_expandableContent__EwFxh textLegalS_className__3wL71 Footer_legal__YIebs">
              <p id="newsletter-policy">
                By subscribing, you confirm that you have read the{" "}
                <button
                  type="button"
                  id="expand-checkbox"
                  className="ExpandableTextByLink_expander__ST8Mr GenericStyles_anchor__uq5eo textBodyLinkS_className__gkmfD"
                  aria-expanded="false"
                >
                  Privacy Policy
                </button>
                .
              </p>
            </div>
          </div>
        </div>
      </main>

      <Footer />
    </body>
  );
}

export default Terms;
